module.exports = __webpack_public_path__ + "img/user.dd216636.png";